import * as ActionTypes from './actionTypes';
import { createSyncAction } from '@bimser/core';
import { IWebInterfaceAction, WebInterfaceActionFactoryFromJS } from 'common/entities';

export function iframeOnLoadTransaction(data: IWebInterfaceAction) {
	const payload = WebInterfaceActionFactoryFromJS(data);
	return createSyncAction(ActionTypes.IFRAME_ONLOAD, payload);
}
